import React from 'react';
import { Alert as JoyAlert, AlertProps as JoyAlertProps } from '@mui/joy';
import { 
  CheckCircleIcon, 
  ExclamationTriangleIcon, 
  InformationCircleIcon,
  XCircleIcon 
} from '@heroicons/react/24/outline';
import { cn } from '@utils/cn';

interface AlertProps extends Omit<JoyAlertProps, 'color'> {
  variant?: 'soft' | 'outlined' | 'solid';
  color?: 'success' | 'warning' | 'danger' | 'neutral';
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
}

const iconMap = {
  success: CheckCircleIcon,
  warning: ExclamationTriangleIcon,
  danger: XCircleIcon,
  neutral: InformationCircleIcon,
};

export const Alert: React.FC<AlertProps> = ({
  variant = 'soft',
  color = 'neutral',
  children,
  className,
  onClose,
  ...props
}) => {
  const Icon = iconMap[color];

  return (
    <JoyAlert
      variant={variant}
      color={color}
      startDecorator={<Icon className="w-5 h-5" />}
      endDecorator={
        onClose && (
          <button
            onClick={onClose}
            className="ml-auto hover:opacity-70 transition-opacity"
          >
            <XCircleIcon className="w-4 h-4" />
          </button>
        )
      }
      className={cn(
        'transition-all duration-300',
        'animate-slideIn',
        className
      )}
      {...props}
    >
      {children}
    </JoyAlert>
  );
};